import { reportData } from "./reportDataConsent.js";
import api from "../api.ts";
import axios from 'axios';
import _ from "lodash";
import moment from 'moment';
import gql from "graphql-tag";
let printURL;
const initialTime = -30610253143000; // 初始时间1000-01-01 00:00:00
const initialTimeFormat = '1000-01-01';
const getAge = function (birthday, age, createdTime) {
  let showAge;
  if (birthday !== initialTime && birthday !== initialTimeFormat && birthday !== '') {
    showAge = moment().diff(birthday, 'years');
  } else if (Number(age) > -1) {
    showAge = Number(age) + moment().diff(createdTime, 'years');
  }
  return showAge;
};

export default {
  name:"printPDFConsent",
  data() {
    return {
      reportData: reportData,
      fullscreenLoading: false,
      printPDF_isClose: false,
      printBtn: false
    }
  },
  mounted() {
    const ifrm = this.$refs.iframePDF;
    ifrm.onload = () => {
      setTimeout(() => {
        ifrm.contentWindow.focus();
        ifrm.contentWindow.print();
      }, 100);
    };
  },
  methods: {
    headerChoice(status,hospitalTitle,logoSrc){
      // 没有医院标题+没有logo
      let NoHosipitalTile={};
      NoHosipitalTile.titleNormal =	{text:"皮肤肿物切除术/组织活检术知情同意书", alignment: 'center',fontSize: 18,bold: true,margin: [0,15,0,5]};
      NoHosipitalTile.margin = [ 30, 75, 30, 75 ];
      // 有医院标题没有logo
      let hasHosipitalTileNotLogo={};
      hasHosipitalTileNotLogo.titleNormal =	{text:"皮肤肿物切除术/组织活检术知情同意书", alignment: 'center',fontSize: 18,bold: true,margin: [0,5,0,5]};
      hasHosipitalTileNotLogo.titleHospital =	{text:hospitalTitle, alignment: 'center',fontSize: 18,bold: true,margin: [0,15,0,0]};
      hasHosipitalTileNotLogo.margin = [ 30,80, 30, 75 ];
      // 有医院标题logo
      let hasHosipitalTileAndLogo={};
      hasHosipitalTileAndLogo.titleHospital ={
				id:"reportLogo",
				columns: [
          {image:logoSrc,fit: [900, 85],margin: [0,10,0,0],width:"100%",alignment: 'center'},
					// {id:"reportTitle",text:hospitalTitle,fontSize: 24,bold: true,margin: [0,20,20,0],width:'80%', alignment: 'center'},
					
        ], 
        alignment: 'center'
      };
      hasHosipitalTileAndLogo.titleNormal =	{text:"皮肤肿物切除术/组织活检术知情同意书", alignment: 'center',fontSize: 24,bold: true,margin: [0,5,0,0]};
      // hasHosipitalTileAndLogo.titleHospital ={
			// 	id:"reportLogo",
			// 	columns: [
      //     {image:logoSrc,fit: [100, 100],alignment: 'right',margin: [0,10,10,10]},
			// 		{id:"reportTitle",text:[
			// 			{text: hospitalTitle,  width:'100%'},
			// 			// {text: "\n"+'皮肤影像检查报告单',  width:'100%'},
			// 		], alignment: 'center',fontSize: 24,bold: true,margin: [30,28,0,0],width:'75%'},
					
      //   ], 
      //   alignment: 'center'
			// };
      hasHosipitalTileAndLogo.margin = [ 30, 165, 30, 75 ];
      if(status == 3){
        return hasHosipitalTileAndLogo
      }else if(status == 2){
        return hasHosipitalTileNotLogo

      }else{
        return NoHosipitalTile
      }

    },
    async postInfo() {
      try {
        // await this.showimgData();
        this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let NewRepoterData = _.cloneDeep(reportData);
        // 修改页眉
        // 1.修改用户信息
        // let itemReportTitle = NewRepoterData.header.find((e) => {
        //   return e.id == "reportTitle";
        // });
        // let itemReportLogo = NewRepoterData.header.find((e) => {
        //   return e.id == "reportLogo";
        // });
        // itemReportLogo
          let reportTitle = await this.$apollo.query({
            query: gql`{
                me{
                    id,
                    report_title
                }
            }`,
            fetchPolicy: "no-cache"
        });
        this.printreport_title = reportTitle.data.me.report_title;
        let logo ='';
          if(!_.isEmpty( this.printreport_title)){
            let titleData = this.headerChoice(1);
		
            NewRepoterData.content.unshift({ id:"title",text:this.printreport_title, alignment: 'center',fontSize: 18,bold: false,margin: [0,5,0,0]});
            // NewRepoterData.pageMargins=titleData.margin;
          }
        let itemHeader = NewRepoterData.header.find((e) => {
          return e.id == "header";
        });
         // 1.修改用户信息
         let itemPatientsName = NewRepoterData.content.find((e) => {
          return e.id == "patientsName";
        });
        // 算年龄
        const age = getAge(this.print_consent_patinet.birthday, this.print_consent_patinet.age, this.print_consent_patinet.created_time);
        itemPatientsName.columns[0].text.push(this.print_consent_patinet.name);
        itemPatientsName.columns[1].text.push(this.print_consent_patinet.gender);
        itemPatientsName.columns[2].text.push(age);
        itemPatientsName.columns[3].text.push(this.print_consent_patinet.id_in_hospital);
        // 2.診斷
        let itemDiagnoses= NewRepoterData.content.find((e) => {
          return e.id == "diagnoses";
        });
        itemDiagnoses.text = this.print_consent_patinet.diagnoses;
        // 3.通知病情
        let itemNotice= NewRepoterData.content.find((e) => {
          return e.id == "notice";
        });
        itemNotice.columns[0].text[0].text = itemNotice.columns[0].text[0].text.replace('&',this.print_consent_patinet.diagnoses);















        
        let response = await axios.request({
          method: 'post',
          url: api.pdfmake,
          responseType: 'arraybuffer',
          data: NewRepoterData
        });
        if (this.printreport_isDownLoad) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          this.openDownloadDialog(blob, `${this.printreport_data.name}-${this.printreport_images.time}.pdf`);
          this.$loading().close();
        } else {
          this.$loading().close();
          this.print(response.data);
        }
      } catch (error) {
        console.log(error)
        this.$loading().close();
        alert("报告转换失败");
      }
    },
    replaceHostory(id, data, NewRepoterData) {
      if (data !== '') {
        (NewRepoterData.content.find((e) => { return e.id == id; })).columns[1].text += data;
      } else {
        const index = NewRepoterData.content.findIndex((e) => {
          return e.id == id;
        });
        NewRepoterData.content.splice(index, 1);
        //   NewRepoterData.content.splice(index,0);
      }
    },
    print(data) {
      const blob = new Blob([data], { type: 'application/pdf' });
      if (printURL) {
        URL.revokeObjectURL(printURL);
      }
      printURL = URL.createObjectURL(blob);
      const ifrm = this.$refs.iframePDF;

      ifrm.src = printURL;

    },
    openDownloadDialog(url, saveName) {
      if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      var aLink = document.createElement('a');
      aLink.href = url;
      aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event;
      if (window.MouseEvent) event = new MouseEvent('click');
      else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    },


  }
}
